
<template>
<!-- 选择合同 -->
    <div>
      
                <!-- :projectId="form.projectId" -->
                 <el-form ref="searchFormRef" :model="query" label-width="80px" size="small">
          <el-row :gutter="20">
            <el-col span="6">
              <el-form-item label="合同类型" prop="type">
                <el-select v-model="query.type" placeholder="请选择合同类型" style="width: 100%">
                  <el-option
                    v-for="(item, index) in projectContractTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> 
             <el-col span="6">
              <el-form-item label="合同名称" prop="name">
                <el-input  v-model="query.name" maxlength="50" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同对象" prop="partnerId">
                <el-select
                  v-model="query.partnerId"
                  placeholder="请选择合同对象"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in partnerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="4">
              <el-button type="primary" @click="searchBtn" size="small"> 搜索 </el-button>
              <el-button @click="searchClear" size="small"> 重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
        <!-- <el-radio-group v-model="radio"> -->
        <avue-crud
            :option="option"
            :table-loading="loading"
            :data="contractList"
            :page.sync="page"
            v-model="selectForm"
            ref="crud"
            @current-change="currentChange"
            @size-change="sizeChange"
            
            @on-load="search"
            @refresh-change="search">
            
            <template slot="choice" slot-scope="scope">
                <el-radio v-model="radio" :label="scope.row" @change='radioChange()'> {{' '}}</el-radio>
            </template>
            <template slot="settledAmount" slot-scope="scope">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.settledAmount)   }}</span></div>
            </template>
            <template slot="unsettledAmount" slot-scope="scope">
                <div class="money"><span>{{tool.money_format_allowvoid(scope.row.unsettledAmount)   }}</span></div>
            </template>
            <template slot="contractAmount" slot-scope="scope">
                 <div class="money"><span>{{tool.money_format_allowvoid(scope.row.contractAmount)  }}</span></div>
            </template>
        </avue-crud>
        <!-- </el-radio-group> -->
         <div class="btnArea">
            <el-button type="primary" v-show="operateStatus!=3" @click="submitContract">提交</el-button>
         </div>
      
        
    </div>
</template>

<script>
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import { getPartnerList } from '@/api/crmedical/contract/contract/contract';
import { getConstractList } from '@/api/crmedical/contract/choiceContract/index.js';
export default {
  props: ['projectId']
    
  ,
  data() {
    return {
      projectContractTypeList: [], //合同类型
      partnerList: [], //合同对象
      radio: '',
      contractList: [],
      option: {
        page: true,
        height:'auto',
        align: 'center',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border:true,
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
          },
          {
            label: '合同编号',
            prop: 'code',
          },
          {
            label: '合同名称',
            prop: 'name',
          },
          {
            label: '合同类型',
            prop: 'type',
            type: 'select',
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl:
              '/api/v4ward/projectDict/dictionary?code=project_contract_type&&projectId=' +
              this.projectId,
          },
          {
            label: '合同对象',
            prop: 'partnerName',
          },
          {
            label: '签订日期',
            prop: 'signTime',
            format: 'yyyy-MM-dd',
            type: 'date',
          },
          {
            label: '合同金额',
            prop: 'contractAmount',
             slot:true,
          },
          {
            label: '已结算金额',
            prop: 'settledAmount',
            slot:true,
          },
          {
            label: '未结算金额',
            prop: 'unsettledAmount',
            slot:true,
          },
          // {
          //   label: '备注',
          //   prop: 'remark',
          // },
        ],
      },
      query: {
        type: '',
        partnerId: '',
        name: '',
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      form: {},
    };
  },
  created() {
    this.search()
    this.getContractType();
    console.log(this.projectId)
  },
  methods: {
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
     
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      
    },
    searchBtn(){
      this.page.currentPage = 1 
      this.search()
    },
    search() {
      this.radio = ''
      getConstractList({
        projectId: this.projectId,
        type: this.query.type,
        partnerId: this.query.partnerId,
        name: this.query.name,
        current:this.page.currentPage,
        size:this.page.pageSize
      }).then(({ data }) => {
        this.contractList = data.records;
        this.page.total = data.total;
      });
    },
    radioChange() {
      console.log(this.radio);
    },
    //提交
    submitContract() {
      this.$emit('getConstract', this.radio);
      
    },
    searchClear() {
     this. query={
        type: '',
        partnerId: '',
        name: '',
      }
    },
    //获取合同类型
    getContractType() {
      Promise.all([
        getProjectDict({
          projectId: this.projectId,
          code: 'project_contract_type',
        }),
        getPartnerList({ id: this.projectId }),
      ]).then((res) => {
        this.projectContractTypeList = res[0].data;
        this.partnerList = res[1].data;
        this.onLoad();
      });
    },
    
  },
};
</script>

<style scoped>
.btnArea {
  widows: 100%;
  text-align: center;
  margin-top: 20px;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
</style>
